import React from 'react';
import Illustration from './illustrations/Illustration';
import { Row } from '@paypalcorp/pp-react';

function PendingWarning() {
  return (
    <Row align="center">
      <Illustration type="warning" />
    </Row>
  );
}

export default PendingWarning;
